import React from 'react';
import './css/Main.css';

import { Link } from 'react-router-dom';

export default function MainCTA() {
  return (
    <section>
      <div className="cta">
        <h2>READY TO SELL YOUR CAR?</h2>
        <p>
          Experience a fairer, safer and smarter way to trade used cars.
        </p>
        <br /><br />
        <Link to="https://wa.me/601125829096" className="btn btn-secondary" style={{"background":"white"}}>
          GET STARTED
        </Link>
      </div>
    </section>
  )
}